import {
    FETCH_INVOICE_DATA_REQUEST,
    FETCH_INVOICE_DATA_SUCCESS,
    FETCH_INVOICE_DATA_FAILURE,
  } from "./FetchInvoiceDataTypes";
  
  const initialState = {
    loading: false,
    invoiceData: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_INVOICE_DATA_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_INVOICE_DATA_SUCCESS:
        return {
          loading: false,
          invoiceData: action.payload,
          error: "",
        };
      case FETCH_INVOICE_DATA_FAILURE:
        return {
          loading: false,
          invoiceData: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  